( function(){
  'use strict';

  angular.module('eclipseApp.checkout').controller('takeItWithYouCtrl', ['$scope', 'fulfillmentOptions', function($scope, fulfillmentOptions){

    $scope.$on('$viewContentLoaded', function(){
      $scope.$parent.resetScope();
      console.log('@takeItWithYouCtrl:VIEWCONTENTLOADED', $scope.fulfillment);
    });
  }]);
})();
